// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"preview_wrapper__2nEvz","content":"preview_content__1Rs4k","preview":"preview_preview__1ACTf","mobileContainar":"preview_mobileContainar__uQWIk"};